export function formatDate(value, opts = {}) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...opts,
  });
}

export function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function relativeTime(value) {
  if (!value) return '';
  const d = new Date(value);
  const diff = (Date.now() - d.getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const units = [
    ['year', 31536000],
    ['month', 2592000],
    ['week', 604800],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
  ];
  for (const [unit, secs] of units) {
    if (Math.abs(diff) >= secs) return rtf.format(-Math.round(diff / secs), unit);
  }
  return 'just now';
}

export function truncate(text, length = 140) {
  if (!text) return '';
  const clean = String(text).replace(/<[^>]+>/g, '');
  return clean.length > length ? `${clean.slice(0, length).trim()}…` : clean;
}

export const STATUS_META = {
  draft: { label: 'Draft', cls: 'bg-surface-gray text-ink-soft' },
  pending: { label: 'Pending Review', cls: 'bg-gold-100 text-gold-800' },
  approved: { label: 'Approved', cls: 'bg-blue-100 text-blue-800' },
  published: { label: 'Published', cls: 'bg-green-100 text-green-800' },
  rejected: { label: 'Rejected', cls: 'bg-red-100 text-red-700' },
};

export function statusMeta(status) {
  return STATUS_META[status] || { label: status, cls: 'bg-surface-gray text-ink-soft' };
}

export function cx(...args) {
  return args.filter(Boolean).join(' ');
}
